import React from 'react';
import { Layout } from 'element';
import { RosterSettingsHeader } from '../../components/RosterSettingsHeader';
import { DutiesByLocation } from './DutiesByLocation';

function Duties() {
  return (
    <>
      <Layout.Header>
        <RosterSettingsHeader activeTab="duties" />
      </Layout.Header>
      <Layout.Content>
        <DutiesByLocation />
      </Layout.Content>
    </>
  );
}

export default Duties;


